import {Trans} from '@lingui/macro';
import React from 'react';

import {makeEnumTypeGuard} from '../../../libs/shared/helpers/src/typescript/enumHelpers';
import {BusinessHour, BusinessHours} from '../../models/api/businessHoursModel';
import {CalendarWeekDaysShortEnum} from '../../models/api/calendarCommonTypes';

/**
 * Check whether a business hours config has any configured hours, or is empty.
 */
export function hasAnyBusinessHour(hours: BusinessHours) {
  const isCalendarWeekDaysShortEnum = makeEnumTypeGuard(CalendarWeekDaysShortEnum);
  const businessHoursEntries: ReadonlyArray<[string, BusinessHour | null]> = Object.entries(hours);
  return businessHoursEntries.some(
    ([day, businessHours]) => isCalendarWeekDaysShortEnum(day) && businessHours !== null,
  );
}

export function getBusinessHoursSaveDialogTitle(name: string) {
  return <Trans id="update-business-hours-dialog-title">Update business hours for {name}?</Trans>;
}

export function getBusinessHoursSaveDialogBody() {
  return (
    <Trans id="update-business-hours-dialog-body">
      This change will affect existing rules referencing inbox business hours, including SLA rules. Analytics
      will use these updated hours for future conversations, but data from past conversations will remain.
    </Trans>
  );
}

export function getBusinessHoursClearDialogTitle(name: string) {
  return <Trans id="clear-business-hours-inbox-title">Clear business hours for {name}?</Trans>;
}

export function getBusinessHoursClearDialogBody() {
  return (
    <Trans id="clear-business-hours-inbox-body">
      This change will affect existing rules referencing inbox business hours, including SLA rules. Analytics
      will no longer reference these business hours for future conversations, but data from past conversations
      will remain.
    </Trans>
  );
}

export function getBusinessHoursSaveConfirmLabel() {
  return <Trans id="save-business-hours-confirm">Save</Trans>;
}

export function getBusinessHoursClearConfirmLabel() {
  return <Trans id="clear-business-hours-confirm">Clear business hours</Trans>;
}
